import DOMPurify from 'dompurify'

const defaultOptions = {
  // lets allow the tags that we want to use
  ALLOWED_TAGS: [
    'div',
    'a',
    'b',
    'p',
    'i',
    'strong',
    'ul',
    'li',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'br',
  ],
  ALLOWED_ATTR: ['href', 'class', 'target', 'id', 'alt', ''],
}

export const sanitizeHtmlContent = (
  content: string,
  options = defaultOptions,
) => DOMPurify.sanitize(content, options)
